import { forIn } from "lodash";
import store from "@/store";
import isArray from "lodash/isArray";

export function convertFormToApi(form = {}) {
  const source = {};
  forIn(form, (value, key) => {
    if (value) {
      if (!isArray(value)) {
        source[key] = value;
      } else if (value.length > 0) {
        const arraySourcers = ["natureza_juridica", "ods", "nacionalidade"];
        if (arraySourcers.includes(key)) {
          source[key] = value;
        } else {
          const index = key == "estado" ? "sigla" : "id";
          source[key] = value.map((v) => v[index]);
        }
      }
    }
  });
  return source;
}

export async function convertQueryToApi(query) {
  const form = await convertQuery(query);

  return convertFormToApi(form);
}

export async function convertQuery(query) {
  const cachedMunicipios = await store.dispatch(
    "municipios/ActionGetAllMunicipios"
  );
  const cachedStates = await store.dispatch("municipios/ActionGetAllEstados");
  const cachedAreas = await store.dispatch("areas/ActionArvore");
  const cachedOds = await store.dispatch("oportunidades/ActionGetOds");

  const form = {};
  await forIn(query, (value, key) => {
    if (key == "estado") {
      value = isArray(value) ? value : [value];
      const values = cachedStates.filter((v) => value.indexOf(v.sigla) >= 0);
      form[key] = values;
    } else if (key == "municipio") {
      value = isArray(value)
        ? value.map((v) => parseInt(v))
        : [parseInt(value)];
      const values = cachedMunicipios.filter((v) => value.indexOf(v.id) >= 0);
      form[key] = values;
    } else if (key == "ods") {
      value = isArray(value)
        ? value.map((v) => parseInt(v))
        : [parseInt(value)];
      const values = cachedOds.filter((v) => value.indexOf(v.id) >= 0);
      form[key] = values;
    } else if (key == "areas") {
      value = isArray(value)
        ? value.map((v) => parseInt(v))
        : [parseInt(value)];
      const values = cachedAreas.filter((v) => value.indexOf(v.id) >= 0);
      form[key] = values;
    } else if (key === "nacionalidade" && value) {
      form[key] = isArray(value) ? value : [value];
    } else {
      form[key] = value;
    }
  });
  return form;
}
